import { STEP } from './step.actions.js';
import { STATE_CHANGE_SUCCESS } from '../router/router.utils';

const INIT_STATE = {};

export function StepReducer(state = INIT_STATE, { type, payload }) {
  switch (type) {
    case STEP.SET_CURRENT:
    case STEP.IS_TERMINAL_ROUTE:
      return { ...state, ...payload };
    case STEP.GO_TO_NEXT:
      return {
        ...state,
        isTerminalRoute: false,
      };
    case STATE_CHANGE_SUCCESS:
      return {
        ...state,
        isTerminalRoute: false,
      };
    case STEP.CLEAR_CURRENT:
      return {
        ...state,
        current: null,
      };
    case STEP.SET_PERSONALIZED_STEPS:
      return {
        ...state,
        chosenSteps: payload.chosenSteps,
      };
    default:
      return state;
  }
}
